"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInternalState = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("./event-callback-hook");
function useInternalState(external, inCondition, outCondition) {
    const [value, setValue] = (0, react_1.useState)(external.value);
    const [synced, setSynced] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (inCondition(value, external.value)) {
            setValue(external.value);
            setSynced(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [external.value, inCondition]);
    const onChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        setValue(value);
        if (outCondition(value)) {
            external.onChange(value);
            setSynced(true);
        }
        else {
            setSynced(false);
        }
    });
    return [value, onChange, synced];
}
exports.useInternalState = useInternalState;
//# sourceMappingURL=internal-state-hook.js.map